import TranslationText from '@Components/Utilities/TranslationText';

const CompareCheckbox = (props) => {
    // add tooltip to checkbox if disabled
    const tooltipText = props.IsDisabled? 'Compare options are full' : '';
    return (
        <>             
            <label htmlFor={'compare-checkbox-' + props.Id} className={'compare-listings ' + props.classNames ? props.classNames : ''}>
                <div title={tooltipText} className='compare-listings__label'>            
                    <input disabled={props.IsDisabled} type='checkbox' id={'compare-checkbox-' + props.Id} className='compare-listings__checkbox' onChange={props.UpdateCompareListing} checked={props.IsCheckedForCompare} />
                    <strong style={{ color: props.IsDisabled && 'rgb(170,170,170)'}} className='compare-listings__label-text'><TranslationText tKey='sandhills.compare' /></strong>
                </div>
            </label>
            {(props.IsCheckedForCompare || props.ShowCompareURL) &&
                
                <a className='compare-listings_checked' href={props.CompareUrl}>
                    <div>
                        <i class="fas fa-external-link" style={{ width: '16px'}} ></i>
                        <strong><TranslationText className='compare-listings__link' tKey='Sandhills.CompareSelectedListings' /></strong>
                    </div>
                </a>
                }               
        </>
    );
};

export default CompareCheckbox;